
import React from 'react';
import { ArchiveFile } from '../types';

interface ProfileWikiProps {
  files: ArchiveFile[];
  onFileSelect: (file: ArchiveFile) => void;
  onBack: () => void;
}

const ProfileWiki: React.FC<ProfileWikiProps> = ({
  files,
  onFileSelect,
  onBack
}) => {
  return (
    <div className="flex flex-col h-full bg-[#fbfaf6] dark:bg-stone-900 transition-colors duration-300">
      <div className="flex-1 overflow-y-auto custom-scrollbar p-6 lg:p-10">
        <div className="max-w-4xl mx-auto space-y-4 pb-20">
          <div className="mb-6">
              <h2 className="text-2xl font-serif font-bold text-stone-800 dark:text-stone-100">My Wiki Pages</h2>
              <p className="text-sm text-stone-500 mt-1">Articles and historical entries authored by you.</p>
          </div>

        {files.map(file => (
          <div 
            key={file.id}
            className="group bg-white dark:bg-stone-800 border border-stone-200 dark:border-stone-700 rounded-2xl p-6 hover:border-amber-500/50 transition-all cursor-pointer shadow-sm relative"
            onClick={() => onFileSelect(file)}
          >
            <div className="flex items-start justify-between gap-6">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-black text-amber-600 dark:text-amber-400 uppercase tracking-[0.2em]">Author</span>
                  <span className="text-[10px] text-stone-300">•</span>
                  <span className="text-[10px] text-stone-400 font-bold uppercase tracking-wider">{file.lastModified || 'Recent'}</span>
                </div>
                <h4 className="text-lg font-serif font-bold text-stone-800 dark:text-stone-100 group-hover:text-amber-600 transition-colors">
                  {file.name}
                </h4>
                {file.description && (
                  <p className="text-sm text-stone-500 dark:text-stone-400 mt-2 line-clamp-2">
                    {file.description}
                  </p>
                )}
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-50 dark:bg-stone-900 group-hover:bg-amber-50 dark:group-hover:bg-amber-900/20 text-stone-300 group-hover:text-amber-500 transition-all">
                <i className="fa-solid fa-chevron-right text-xs"></i>
              </div>
            </div>
          </div>
        ))}

        {files.length === 0 && (
          <div className="text-center py-20 bg-stone-50 dark:bg-stone-900/30 rounded-2xl border-2 border-dashed border-stone-200 dark:border-stone-800">
             <i className="fa-solid fa-file-signature text-stone-200 dark:text-stone-700 text-6xl mb-4"></i>
             <h4 className="font-bold text-stone-800 dark:text-stone-200 uppercase tracking-widest">No Pages Authored</h4>
             <p className="text-sm text-stone-400 mt-2">Use the Wiki search or editor to create your first archival entry.</p>
          </div>
        )}
      </div>
    </div>
  </div>
  );
};

export default ProfileWiki;
